const handleAppPaymentRedirection = (
  query,
  state,
  relativeLink,
  goalUID,
  orderId
) => {
  const { inside_app, app_redirection } = query ?? {};
  if (inside_app === 'true' && app_redirection === 'true') {
    const url = relativeLink || `/goal/-/${goalUID}`;
    const queryParams = new URLSearchParams();
    switch (state) {
      case 'thankyou':
        queryParams.append('show_thank_you', true);
        queryParams.append('order_id', orderId);
        break;
      case 'home':
        queryParams.append('goal_uid', goalUID);
        break;
      case 'cash':
        queryParams.append('show_cash_screen', true);
        queryParams.append('goal_uid', goalUID);
        break;
      default:
        break;
    }
    queryParams.append('navigation_reset', true);
    window.open(`${url}/subscribe?${queryParams.toString()}`, '_self');
    return true;
  }
};

export default handleAppPaymentRedirection;
